import { Button } from "react-aria-components";
import FormSelectWrapper from "../entityComponents/Form/components/FormSelectWrapper";
import { EntityNames } from "../../../enums/EntityNames";
import FormToggleWrapper from "../entityComponents/Form/components/FormToggleWrapper";
import { modalSignal } from "../Modal/ModalContainer";
import ConfirmModal from "../Modal/ConfirmModal";
import { httpGet, httpPost } from "../../../modules/Backend";
import { HttpStatusCode } from "axios";
import { navigate } from "@reach/router";
import { useEffect } from "react";
import { movingSidePanelSignal, staticSidePanelSignal } from "../layout/Layout";
import { Change } from "../../lib/wizard/Wizard";
import { useMainConfig } from "../../../modules/config/MainConfigContext";


interface Step1Props {
  displayName: string
  nextStep?: () => void;
  handleChange?: (input: string) => (value: any) => void;
  handleChangeBatched?: (changes: Change[]) => void;
  values?: Record<string, any>;
  errors?: Record<string, string>;
  cancel?: () => void
}

const RecallStep1: React.FC<Step1Props> & { validate?: (values: Record<string, any>) => Record<string, string> } = ({
  displayName,
  nextStep,
  handleChange,
  handleChangeBatched,
  values,
  errors,
  cancel
}) => {
  const { config } = useMainConfig();

  function HandleContinuePress() {
    if (!!values?.recallId) {
      nextStep!()
    } else {
      OpenContinueModal()
    }
  }

  function OpenContinueModal() {
    modalSignal.value = <ConfirmModal
      heading="Do you want to continue?"
      information="The options on this page cannot be changed after continuing"
      ContinueFunc={SaveAndContinue} />
  }

  async function SaveAndContinue() {
    const result = await httpPost("api/recalls/init", values)

    if (result.status === HttpStatusCode.Ok) {
      // Check canEdit before proceeding
      if (result.data.id) {
        const canEditResult = await httpGet(`api/recalls/canEdit?id=${result.data.id}`)
        if (canEditResult.status !== HttpStatusCode.Ok || !canEditResult.data?.canEdit) {
          window.history.back()
          return
        }
      }
      
      // Set both recallId and accountId from the response using batched update
      const changes: Change[] = [
        { value: result.data.id, elementName: "recallId" }
      ];
      
      if (result.data.accountId) {
        changes.push({ value: result.data.accountId, elementName: "accountId" });
      }
      
      if (result.data.reference) {
        changes.push({ value: result.data.reference, elementName: "fullRef" });
      }
      
      if (handleChangeBatched) {
        handleChangeBatched(changes);
      }
      
      navigate(`/CreateRecall/${result.data.id}`, { replace: true })
      nextStep!()
    }
  }


  useEffect(() => {
    staticSidePanelSignal.value = undefined
  }, [])

  return (
    <div>
      {config?.itemCountExplanation && (
        <div className="recall-wizard__info-wrapper">
          <p><b>Please note that</b> {config.itemCountExplanation}</p>
        </div>
      )}
      <div className="recall-wizard__settings-wrapper">
        <FormSelectWrapper value={values?.accountId} disabled={!!values?.recallId} label="Account" entityName={EntityNames.accounts} required={true} onChange={handleChange!("accountId")} />
        {config?.digitalRecallsEnabled && (
          <FormToggleWrapper value={values?.isDigital} disabled={!!values?.recallId} label="Digital Recall?" onChange={handleChange!("isDigital")} />
        )}
      </div>

      <div className="recall-wizard__footer">
        <Button className=" button button--large button--secondary button--with-icon" onPress={cancel}>
          <p className="button-text">Back</p>
        </Button>
        <Button className=" button button--large button--primary button--with-icon" isDisabled={errors != undefined && Object.keys(errors).length > 0} onPress={HandleContinuePress}>
          <p className="button-text">Continue to select inventory</p>
        </Button>
      </div>
    </div>
  );
};

RecallStep1.validate = (values: Record<string, any>) => {
  const errors: Record<string, string> = {};
  if (!values.accountId) {
    errors.firstName = 'Account is required';
  }
  return errors;
};

export default RecallStep1;